require('widgets/setupSidebarHotNews')
